import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => ({
    formBox: {
        backgroundColor: "#fff",
        borderRadius: "20px",
        alignSelf: "center",
        marginBottom:"48px",
        width:"400px",
        boxShadow: "5px 10px 18px #888888",
        padding:"30px"
    },
    pageTitleContainer: {
        display: "flex",
        flexDirection: "row",
        marginBottom: "50px"
    },
    pageContainer: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#F5F6F9",
    },
    formTitle: {
        fontFamily: "PoppinsBold",
        fontSize: "24px",
        color: "#bb0d66",
        alignSelf: "center",
        marginBottom: "16px"
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
        backgroundColor: "#BB0D66",
        color: "#fff",
        "&:hover": {
            backgroundColor: "#8a0046"
        }
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative'
    },
    wrongPassphrase: {
        fontFamily: "PoppinsBold",
        fontSize: "16px",
        color: "#d73232",
        textAlign: "center",
        margin: "8px 0"
    },
    rightPassphrase: {
        fontFamily: "PoppinsBold",
        fontSize: "16px",
        color: "#75ce2b",
        textAlign: "center",
        margin: "8px 0"
    },
    redirectingPassphrase: {
        fontFamily: "EncodeSansRegular",
        fontSize: "12px",
        color: "#a1a1a1",
        alignSelf: "center",
    }
}));
